import React from 'react';

const BodyworkServiceSection = () => {
  return (
    <>
      <style jsx>{`
        .bodywork-service-section {
          background: white;
          position: relative;
          overflow: hidden;
          min-height: 500px;
        }

        .bodywork-content-wrapper {
          display: flex;
          align-items: stretch;
          min-height: 500px;
          position: relative;
        }

        .bodywork-text-content {
          flex: 1;
          padding: 80px 0px;
          padding-left: 60px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;
          z-index: 2;
        }

        .bodywork-service-header {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 40px;
          animation: bodyworkFadeInLeft 0.8s ease-out;
        }

        .bodywork-icon {
          font-size: 3rem;
          animation: bodyworkIconSpin 6s ease-in-out infinite;
        }

        @keyframes bodyworkIconSpin {
          0%, 100% { transform: rotate(0deg) scale(1); }
          25% { transform: rotate(5deg) scale(1.1); }
          50% { transform: rotate(0deg) scale(1); }
          75% { transform: rotate(-5deg) scale(1.1); }
        }

        .bodywork-service-title {
          font-size: 2.8rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.1);
        }

        .bodywork-service-description {
          font-size: 1.3rem;
          color: #666;
          line-height: 1.8;
          margin: 0 0 50px 0;
          font-family: 'Arial', sans-serif;
          animation: bodyworkFadeInUp 0.8s ease-out 0.3s both;
        }

        .bodywork-cta-button {
          background: #2196F3;
          color: white;
          border: none;
          border-radius: 15px;
          padding: 20px 40px;
          font-size: 1.6rem;
          font-weight: bold;
          cursor: pointer;
          transition: all 0.3s ease;
          max-width: fit-content;
          text-decoration: none;
          box-shadow: 0 8px 25px rgba(33, 150, 243, 0.3);
          animation: bodyworkFadeInUp 0.8s ease-out 0.6s both;
          position: relative;
          overflow: hidden;
        }

        .bodywork-cta-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          animation: bodyworkButtonShine 3s ease-in-out infinite;
        }

        @keyframes bodyworkButtonShine {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        .bodywork-cta-button:hover {
          background: #1976D2;
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(33, 150, 243, 0.4);
        }

        .bodywork-cta-button:focus {
          outline: 3px solid rgba(33, 150, 243, 0.5);
          outline-offset: 2px;
        }

        .bodywork-image-content {
          flex: 1;
          background: url('/images/carosserie.png') center/cover no-repeat;
          position: relative;
          animation: bodyworkSlideInRight 0.8s ease-out 0.4s both;
        }

        .bodywork-image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            135deg,
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0.1) 50%,
            rgba(0,0,0,0.2) 100%
          );
          z-index: 1;
        }

        .bodywork-floating-elements {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 2;
          pointer-events: none;
        }

        .bodywork-paint-drop {
          position: absolute;
          font-size: 2rem;
          animation: bodyworkPaintDrop 4s ease-in-out infinite;
        }

        .bodywork-paint-drop:nth-child(1) {
          top: 20%;
          left: 20%;
          animation-delay: 0s;
        }

        .bodywork-paint-drop:nth-child(2) {
          top: 60%;
          right: 25%;
          animation-delay: 2s;
        }

        .bodywork-paint-drop:nth-child(3) {
          bottom: 30%;
          left: 30%;
          animation-delay: 1s;
        }

        @keyframes bodyworkPaintDrop {
          0%, 100% { 
            transform: translateY(0px) scale(1); 
            opacity: 0.7; 
          }
          50% { 
            transform: translateY(-15px) scale(1.2); 
            opacity: 1; 
          }
        }

        .bodywork-sparkle {
          position: absolute;
          font-size: 1.5rem;
          animation: bodyworkSparkle 3s ease-in-out infinite;
        }

        .bodywork-sparkle:nth-child(4) {
          top: 40%;
          left: 60%;
          animation-delay: 0.5s;
        }

        .bodywork-sparkle:nth-child(5) {
          top: 80%;
          right: 40%;
          animation-delay: 1.5s;
        }

        @keyframes bodyworkSparkle {
          0%, 100% { 
            transform: scale(0) rotate(0deg); 
            opacity: 0; 
          }
          50% { 
            transform: scale(1) rotate(180deg); 
            opacity: 1; 
          }
        }

        @keyframes bodyworkFadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes bodyworkFadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bodyworkSlideInRight {
          from {
            opacity: 0;
            transform: translateX(100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (max-width: 1024px) {
          .bodywork-content-wrapper {
            flex-direction: column;
            min-height: auto;
          }

          .bodywork-text-content {
            clip-path: none;
            padding: 60px 0px;
            padding-left: 40px;
          }

          .bodywork-service-title {
            font-size: 2.4rem;
          }

          .bodywork-service-description {
            font-size: 1.2rem;
          }

          .bodywork-cta-button {
            font-size: 1.4rem;
            padding: 18px 35px;
          }

          .bodywork-image-content {
            min-height: 400px;
          }
        }

        @media (max-width: 768px) {
          .bodywork-text-content {
            padding: 40px 20px;
            text-align: center;
          }

          .bodywork-service-header {
            flex-direction: column;
            text-align: center;
            gap: 15px;
            margin-bottom: 30px;
          }

          .bodywork-service-title {
            font-size: 2rem;
          }

          .bodywork-service-description {
            font-size: 1.1rem;
            text-align: center;
            margin-bottom: 40px;
          }

          .bodywork-cta-button {
            font-size: 1.3rem;
            padding: 16px 30px;
            margin: 0 auto;
          }

          .bodywork-image-content {
            min-height: 300px;
          }

          .bodywork-paint-drop {
            font-size: 1.5rem;
          }

          .bodywork-sparkle {
            font-size: 1.2rem;
          }
        }

        @media (max-width: 480px) {
          .bodywork-text-content {
            padding: 30px 15px;
          }

          .bodywork-service-title {
            font-size: 1.6rem;
          }

          .bodywork-service-description {
            font-size: 1rem;
          }

          .bodywork-cta-button {
            font-size: 1.2rem;
            padding: 14px 25px;
            width: 100%;
            max-width: 280px;
            text-align: center;
          }

          .bodywork-image-content {
            min-height: 250px;
          }

          .bodywork-paint-drop {
            font-size: 1.3rem;
          }

          .bodywork-sparkle {
            font-size: 1rem;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="bodywork-service-section"
        role="region"
        aria-labelledby="bodywork-service-heading"
        itemScope
        itemType="https://schema.org/Service"
      >
        <div className="bodywork-content-wrapper">
          <div className="bodywork-text-content">
            <header className="bodywork-service-header">
              <div className="bodywork-icon" role="img" aria-label="Peinture et carrosserie">🎨</div>
              <h2 
                id="bodywork-service-heading"
                className="bodywork-service-title"
                itemProp="name"
              >
                Carrosserie <span style={{fontSize:20}}>(atelier physique)</span>
              </h2>
            </header>

            <p className="bodywork-service-description" itemProp="description">
              Réparez les impacts, rayures ou bosses grâce<br />
              à nos prestations de carrosserie rapide ou<br />
              complète.<br />
              Estimation gratuite à partir de photos, prise<br />
              en charge rapide et finitions soignées.
            </p>

            <a 
              href="#prendre-rdv-carrosserie" 
              className="bodywork-cta-button"
              role="button"
              aria-label="Prendre rendez-vous pour service de carrosserie"
              itemProp="url"
            >
              Prendre RDV
            </a>
          </div>

          <div 
            className="bodywork-image-content"
            role="img"
            aria-label="Atelier de carrosserie automobile Faucon Bleu"
            itemProp="image"
          >
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Carrosserie automobile - Atelier physique",
              "description": "Service de carrosserie automobile: réparation d'impacts, rayures, bosses. Estimation gratuite à partir de photos, prise en charge rapide et finitions soignées.",
              "provider": {
                "@type": "AutoRepair",
                "name": "Faucon Bleu",
                "url": "https://fauconbleu.ma"
              },
              "areaServed": {
                "@type": "City",
                "name": "Casablanca",
                "addressCountry": "MA"
              },
              "serviceType": "Auto Body Repair",
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Services de carrosserie",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Réparation d'impacts",
                      "description": "Réparation des impacts et chocs sur carrosserie"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Réparation de rayures",
                      "description": "Élimination des rayures sur peinture automobile"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Réparation de bosses",
                      "description": "Débosselage et remise en forme de carrosserie"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Estimation gratuite",
                      "description": "Devis gratuit à partir de photos"
                    }
                  }
                ]
              },
              "offers": {
                "@type": "Offer",
                "name": "Estimation gratuite",
                "description": "Estimation gratuite à partir de photos",
                "price": "0",
                "priceCurrency": "MAD"
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default BodyworkServiceSection;